/**
 * Renderers Markdown compartidos para los dos chats.
 *
 * Mejora "Tablas en el chat" (changelog cliente): ReactMarkdown solo
 * soporta CommonMark estricto, así que las tablas en respuestas del
 * LLM se renderizaban como texto plano con barras `|`. Con `remark-gfm`
 * en `remarkPlugins` ya las parsea, pero la `prose` de Tailwind no las
 * estiliza por defecto. Estos renderers les dan look del DS Meridianos.
 *
 * Las citas `[Fuente N]` siguen funcionando dentro de celdas porque
 * `linkifyCitations` se aplica al contenido ANTES de pasar a Markdown:
 * cuando GFM emite el `<td>`, dentro hay un `<a href="#source-N-...">`
 * que el renderer `a` ya transforma en chip teal.
 */
import type { Components } from "react-markdown";

export const tableComponents: Components = {
  // Wrapper con scroll horizontal: si el LLM devuelve una tabla más
  // ancha que la columna del chat, scrollea dentro sin romper layout.
  table: ({ children }) => (
    <div className="my-3 overflow-x-auto rounded border border-line">
      <table className="w-full border-collapse text-xs">{children}</table>
    </div>
  ),
  thead: ({ children }) => (
    <thead className="bg-surface-100">{children}</thead>
  ),
  // Zebra rows (filas alternas con fondo muy tenue) — ayuda a seguir
  // filas largas con la vista.
  tr: ({ children }) => (
    <tr className="border-b border-line last:border-0 even:bg-surface-100/50">
      {children}
    </tr>
  ),
  th: ({ children }) => (
    <th className="px-3 py-2 text-left font-heading font-semibold text-ink">
      {children}
    </th>
  ),
  td: ({ children }) => (
    <td className="px-3 py-2 align-top text-content">{children}</td>
  ),
};
